import { render, staticRenderFns } from "./UpdateIndicator.vue?vue&type=template&id=5f0f19ce"
import script from "./UpdateIndicator.vue?vue&type=script&lang=js"
export * from "./UpdateIndicator.vue?vue&type=script&lang=js"
import style0 from "./UpdateIndicator.vue?vue&type=style&index=0&id=5f0f19ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports